import { Fragment, ReactNode, useState } from "react";

import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {
  CompatiblePlaceEditor,
  CompatiblePlaceEditorProps,
  DialogWithActions,
} from "..";
import { ServiceCompatiblePlace } from "../../../graphql/models";

export interface CompatiblePlaceEditorButtonWithDialogProps
  extends CompatiblePlaceEditorProps {
  icon?: ReactNode;
  disabled?: boolean;
}

export function CompatiblePlaceEditorButtonWithDialog(
  props: CompatiblePlaceEditorButtonWithDialogProps
) {
  const {
    icon = <EditIcon />,
    disabled,
    onCompatiblePlaceChange: parentOnChange,
    ...rest
  } = props;
  const [open, setOpen] = useState(false);

  const onCompatiblePlaceChange = (place: ServiceCompatiblePlace) => {
    parentOnChange(place);
    setOpen(false);
  };

  return (
    <Fragment>
      <IconButton disabled={disabled} onClick={() => setOpen(true)}>
        {icon}
      </IconButton>
      <DialogWithActions
        fullScreen={false}
        open={open}
        setOpen={setOpen}
        title="Modifica luogo compatibile"
      >
        <CompatiblePlaceEditor
          onCompatiblePlaceChange={onCompatiblePlaceChange}
          {...rest}
        />
      </DialogWithActions>
    </Fragment>
  );
}
